import { type LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { cn } from '@/lib/utils'

export type StatTone = 'teal' | 'green' | 'red' | 'amber' | 'blue' | 'purple'

const TONES: Record<StatTone, string> = {
  teal: 'bg-primary/10 text-primary',
  green: 'bg-success-soft text-success',
  red: 'bg-destructive/10 text-destructive',
  amber: 'bg-peach/25 text-warning',
  blue: 'bg-info-soft text-info',
  purple: 'bg-purple-soft text-purple'
}

interface StatTileProps {
  icon: LucideIcon
  label: ReactNode
  value: ReactNode
  tone?: StatTone
  to?: string
}

export function StatTile({
  icon: Icon,
  label,
  value,
  tone = 'teal',
  to
}: StatTileProps) {
  const inner = (
    <div className="flex items-center gap-3">
      <span
        className={cn(
          'flex h-11 w-11 shrink-0 items-center justify-center rounded-xl',
          TONES[tone]
        )}
      >
        <Icon className="h-5 w-5" />
      </span>
      <div className="min-w-0">
        <div className="truncate text-sm text-muted-foreground">{label}</div>
        <div className="font-display text-xl font-bold leading-tight text-ink">
          {value}
        </div>
      </div>
    </div>
  )

  if (!to) return inner

  return (
    <Link
      to={to}
      className="block rounded-xl transition-colors hover:bg-ink/[0.02]"
    >
      {inner}
    </Link>
  )
}
